import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Layout from "../Utils/Layout";
import { useNavigate } from "react-router-dom";

const DigitalMarketing = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="py-4 fs-3 ps-3 " data-aos="fade-left">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-info fw-bold ms-5"
        >
          Back
        </button>
      </div>
      <div></div>
      <Helmet>
        <title>Digital Marketing Services | Shoyeb</title>
        <meta
          name="description"
          content="Drive brand awareness, generate leads, and increase conversions with our expert digital marketing services."
        />
        <meta
          name="keywords"
          content="digital marketing services, online marketing, internet marketing"
        />
      </Helmet>
      <Container>
        <Row className="mt-5" data-aos="fade-right">
          <Col>
            <h1 className="text-center">Digital Marketing Services</h1>
            <p className="lead text-center">
              Enhance your online presence and grow your business with our
              professional digital marketing solutions.
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={6} data-aos="fade-down">
            <h3>Our Services</h3>
            <ul>
              <li>Social media marketing</li>
              <li>Email marketing campaigns</li>
              <li>Pay-per-click (PPC) advertising</li>
              <li>Content marketing strategies</li>
              <li>Search engine marketing (SEM)</li>
            </ul>
          </Col>
          <Col md={6} data-aos="fade-up">
            <h3>Why Choose Us?</h3>
            <p>
              Our experienced team of digital marketers specializes in crafting
              customized campaigns that drive results. We leverage data-driven
              strategies and innovative techniques to help you achieve your
              business goals.
            </p>
            <p>
              Whether you&apos;re looking to increase brand awareness, generate
              leads, or boost conversions, we can develop a tailored plan to
              meet your objectives.
            </p>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col data-aos="fade-left">
            <h3>Contact Us</h3>
            <p>
              Ready to elevate your digital marketing efforts and achieve your
              business objectives?
            </p>
            <a href="mailto:shoyebmd424@mail.com" className="btn btn-info">
              Contact Us
            </a>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default DigitalMarketing;
